import React from "react"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import * as styles from "./PostBody.module.scss"

const PostBody = (props) => {
  const imgFormatQuery = "?auto=compress&fit=crop&fm=jpg&w=720"

  let { body } = props

  body = body.replace(
    /<img([^>]+)src="[/]?([^"]+)"([^>]*)>|<( *)img( *)[/>|>]/g,
    `<img $1src="$2${imgFormatQuery}" $3>`
  )

  return (
    <Section margin className={styles.PostBody}>
      <SiteWrapper textNarrow className={styles.body}>
        <div dangerouslySetInnerHTML={{ __html: body }} />
      </SiteWrapper>
    </Section>
  )
}

export default PostBody
